<script setup lang="ts">
import { ArrowRightIcon, NotebookPenIcon } from 'lucide-vue-next'
import { TrackdechetsBsdState } from '~/types/graphql-backend-types/gql-types'

const { isProducer } = storeToRefs(useAuthStore())

const { data: collect, isPending } = useBSDCollect({
  hasBSDWithTDStates: isProducer.value
    ? [TrackdechetsBsdState.Draft, TrackdechetsBsdState.Sealed]
    : [TrackdechetsBsdState.Sent, TrackdechetsBsdState.Accepted, TrackdechetsBsdState.SignedByProducer],
})

const { t } = useI18n()
const router = useRouter()
</script>

<template>
  <div v-if="isPending">
    <div class="skeleton h-32 w-full" />
  </div>
  <div v-else-if="collect?.count" class="bg-primary p-8 rounded-xl flex gap-2 items-center text-primary-content">
    <NotebookPenIcon :size="24" />
    <span class="text-lg font-bold">
      {{ t('collect.waiting_for_informations', { count: collect?.count }) }}
    </span>
    <span class="text-xs text-base-primary/70">
      {{ t('collect.waiting_for_informations_subtitle') }}
    </span>
    <Badge color="warning" class="flex gap-1">
      <ArrowRightIcon :size="12" />
      {{ t('documents.todo') }}
    </Badge>
    <EButton class="ml-auto btn-secondary" @click="router.push('/collects/sign-bsds/')">
      {{ t('global.see_all') }}
    </EButton>
  </div>
</template>
